import { Icon } from '@chakra-ui/react'
import { BrandColors } from 'commons/design-system/tokens'
import { FaCircleCheck } from 'react-icons/fa6'

const SuccessIcon = () => {
	return <Icon as={FaCircleCheck} boxSize='96px' color={BrandColors.PRIMARY} />
}

export default SuccessIcon
